import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { getUserIdFromToken } from "../../utils/jwtUtils";
export function getUserIdFromAccessToken(token) {
    return token ? getUserIdFromToken(token) : null;
}
export default function useUserAuth() {
    const { getAccessTokenSilently, loginWithRedirect, isAuthenticated, isLoading, error: auth0Error, } = useAuth0();
    const [userAuth, setUserAuth] = useState({
        userId: null,
        userToken: null,
    });
    const [error, setError] = useState(null);
    useEffect(() => {
        async function getUserAuth() {
            if (isLoading)
                return;
            if (!isAuthenticated) {
                await loginWithRedirect({
                    appState: { returnTo: window.location.pathname },
                });
                return;
            }
            try {
                const accessToken = await getAccessTokenSilently();
                const userIdFromToken = getUserIdFromAccessToken(accessToken);
                setUserAuth({
                    userToken: accessToken,
                    userId: userIdFromToken,
                });
            }
            catch (_error) {
                if (_error instanceof Error) {
                    // eslint-disable-next-line no-console
                    console.error((_error === null || _error === void 0 ? void 0 : _error.message) || "Error accessing user's token");
                    setError(_error);
                }
            }
        }
        getUserAuth();
    }, [isAuthenticated, isLoading, getAccessTokenSilently, loginWithRedirect]);
    return {
        loading: isLoading,
        ...userAuth,
        error: error || auth0Error,
    };
}
//# sourceMappingURL=index.js.map